module.exports = __webpack_public_path__ + "img/videoExample.2331102f.png";